// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sko-page {
    display: flex;
    width: 120px;
    height: 50px;
    border: solid 1px var(--color-foreground);
}

    .sko-page.natural {
        justify-content: right;
    }

    .sko-page.edge {
        justify-content: right;
    }

        .sko-page.edge svg {
            transform: rotate(270deg);
        }

    .sko-page.inverse {
        justify-content: left;
    }

.sko-page-image {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    aspect-ratio: 4/3;
    margin: 5px;
    border: solid 1px var(--color-foreground);
}

    .sko-page-image > svg {
        stroke: var(--color-foreground);
        fill: var(--color-foreground);
    }

.sbe-rotation-title{
    margin-bottom:0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookRotation.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,yCAAyC;AAC7C;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;QAEI;YACI,yBAAyB;QAC7B;;IAEJ;QACI,qBAAqB;IACzB;;AAEJ;IACI,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,yCAAyC;AAC7C;;IAEI;QACI,+BAA+B;QAC/B,6BAA6B;IACjC;;AAEJ;IACI,oBAAoB;AACxB","sourcesContent":["@import '../../css/App.css';\r\n\r\n.sko-page {\r\n    display: flex;\r\n    width: 120px;\r\n    height: 50px;\r\n    border: solid 1px var(--color-foreground);\r\n}\r\n\r\n    .sko-page.natural {\r\n        justify-content: right;\r\n    }\r\n\r\n    .sko-page.edge {\r\n        justify-content: right;\r\n    }\r\n\r\n        .sko-page.edge svg {\r\n            transform: rotate(270deg);\r\n        }\r\n\r\n    .sko-page.inverse {\r\n        justify-content: left;\r\n    }\r\n\r\n.sko-page-image {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    justify-content: center;\r\n    align-items: center;\r\n    aspect-ratio: 4/3;\r\n    margin: 5px;\r\n    border: solid 1px var(--color-foreground);\r\n}\r\n\r\n    .sko-page-image > svg {\r\n        stroke: var(--color-foreground);\r\n        fill: var(--color-foreground);\r\n    }\r\n\r\n.sbe-rotation-title{\r\n    margin-bottom:0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
